import { DEFAULT_LEVEL } from '@atlassian/jira-software-deployments-common-table/src/components/table/common/constants';
import {
	toProjectId,
	toProjectKey,
} from '@atlassian/jira-software-deployments-common-table/src/model/app';
import type {
	Item as TableItem,
	ItemProject as TableItemProject,
} from '@atlassian/jira-software-deployments-common-table/src/model/table';
import type { Issue, Project } from '../../common/types';

export const toTableItem = (issue: Issue): TableItem => ({
	id: issue.id,
	listData: {},
	chartData: {},
});

export const toTableItemProject = (project: Project): TableItemProject => ({
	id: toProjectId(project.id),
	name: project.name,
	key: toProjectKey(project.key),
	itemTypes: {
		[DEFAULT_LEVEL]: project.issueTypes,
	},
	iconUrl: '', // Not needed
});
